import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from '@/common/utils/formatters'
import { CompanyContractConsumptionControlledBy } from '@/features/company/types/contract.type'
import { GovernmentAllocationEntryProductCategory } from '@/features/governmentAllocations/types/governmentAllocationEntry.type'

export const updateGovernmentAllocationEntryProductCategoryDefaultValues = (
  entryProductCategory: GovernmentAllocationEntryProductCategory,
  controlledBy: CompanyContractConsumptionControlledBy = CompanyContractConsumptionControlledBy.Currency,
) => {
  if (controlledBy === CompanyContractConsumptionControlledBy.Quantity) {
    return {
      id: entryProductCategory.id,
      product_category: entryProductCategory.product_category,
      total_quantity: formatDecimalWithGroupedUnit(
        Number(entryProductCategory.total_quantity),
        entryProductCategory.entry_products,
        (p) => p.product.unit_for_quantity,
      ),
      entry_products: entryProductCategory.entry_products.map((productDistribution) => {
        return {
          id: productDistribution.id,
          product: productDistribution.product,
          total_quantity: formatDecimalUnit(Number(productDistribution.total_quantity), productDistribution.product.unit_for_quantity),
        }
      }),
    }
  }

  return {
    id: entryProductCategory.id,
    product_category: entryProductCategory.product_category,
    total_value: formatCurrency(Number(entryProductCategory.total_value) || 0),
    entry_products: entryProductCategory.entry_products.map((productDistribution) => {
      return {
        id: productDistribution.id,
        product: productDistribution.product,
        total_value: formatCurrency(Number(productDistribution.total_value) || 0),
      }
    }),
  }
}
